const ztoBgC = require.context('../assets/bg/zto', true);
const colorfulBgC = require.context('../assets/bg/colorful', true);
const starBgC = require.context('../assets/bg/star', true);
const freshBgC = require.context('../assets/bg/fresh', true);
const taiwanBgC = require.context('../assets/bg/taiwan', true);
const sceneryBgC = require.context('../assets/bg/scenery', true);

const contexts = [
  {
    name: '中通推荐',
    context: ztoBgC,
  },
  {
    name: '明星',
    context: starBgC,
  },
  {
    name: '炫彩',
    context: colorfulBgC,
  },
  {
    name: '风景',
    context: sceneryBgC,
  },
  {
    name: '小清新',
    context: freshBgC,
  },
  {
    name: '台湾特辑',
    context: taiwanBgC,
  }
];

export { contexts }



// WEBPACK FOOTER //
// ./src/pages/background.config.js